export const useAccordion = () => {
    const accordionIndex = ref<number>(-1)

    const toggle = (index: number) => {
        if (accordionIndex.value === index) {
            accordionIndex.value = -1
        } else {
            accordionIndex.value = index
        }
    }

    return {
        accordionIndex,
        toggle
    }
}
